import { useAppDispatch } from '@/store';
import { useGetUserBalanceQuery } from '@/features/usersSlice';
import { Link, useLocation, useMatches } from 'react-router';
import { useEffect, useRef, useState } from 'react';
import { joiningTeam } from '@/store/actions/team';
import { toast } from 'react-toastify';
import { useAuthStore } from '@/store/useAuthStore';
import { useSimulationStore } from '@/store/useSimulationStore';
import { MinutesRemaining } from '@/components/MinutesRemaining';
import TivyChat from './chat-tivy';

interface RouteHandle {
  title: string;
  hideHeader?: boolean;
}

export function Header() {
  const user = useAuthStore(state => state.user);
  const matches = useMatches();
  const location = useLocation();
  const isPlanPage = location.pathname == '/plans' || location.pathname == '/buy-plans';
  const ApicCall = useRef(false);
  const [updateSub, setUpdateSub] = useState(true);
  const { data: balanceData } = useGetUserBalanceQuery(user.id, { refetchOnMountOrArgChange: true });
  const setBalance = useSimulationStore(state => state.setBalance);

  const currentRoute = matches[matches.length - 1];
  const pageTitle = (currentRoute?.handle as RouteHandle)?.title || '';
  const hideHeader = (currentRoute?.handle as RouteHandle)?.hideHeader || false;
  const isDashboard = location.pathname == '/dashboard';

  const userJoinedTeams: any[] = [];
  const joinLink = '';
  const savecallDuration = 0;
  const loadingPlanShowing = false;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (balanceData?.amount !== undefined) {
      setBalance(balanceData.amount);
    }
  }, [balanceData, setBalance]);

  // const getUserSubscription = async () => {
  //   await dispatch(getSubscription()).then(() => {
  //     dispatch(GetUserDeatil({ email: user?.email })).then(() => {});
  //     setUpdateSub(false);
  //     dispatch(showLoadingPlans(false));
  //   });
  // };

  const handleUpdateSimulationTime = async () => {
    // if (savecallDuration != 0 && savecallDuration != undefined) {
    //   if (userJoinedTeams.length == undefined) {
    //     await dispatch(updateSubscription(savecallDuration)).then(() => {
    //       dispatch(setCallDuration(0));
    //     });
    //   } else {
    //     await dispatch(
    //       changeMemberTime({
    //         userId: user?.id,
    //         time: savecallDuration,
    //         teamId: userJoinedTeams[0]?._id,
    //         Manager: user?.isManager
    //       })
    //     ).then(() => {
    //       dispatch(setCallDuration(0));
    //     });
    //   }
    // }
  };

  const calling = async () => {
    if (ApicCall.current == false) {
      // getUserSubscription();
      ApicCall.current = true;
    }
  };
  const handlleJoinRef = useRef(false);
  const [teamJoinLoading, setTeamJoinLoading] = useState(false);
  const handleJoinTeam = async (joinLink: string) => {
    handlleJoinRef.current = true;
    setTeamJoinLoading(true);
    const response = await dispatch(joiningTeam({ JoinLink: joinLink }));
    if (response?.payload?.status) {
      toast.success(response?.payload?.message, { toastId: 'join' });
      window.location.href = '/dashboard'; // Or use history.push if using react-router
      setTeamJoinLoading(false);
    } else {
      toast.error(response?.payload?.message || 'An error occurred', {
        toastId: 'join'
      });
      setTeamJoinLoading(false);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (joinLink && handlleJoinRef.current == false) {
      handleJoinTeam(joinLink);
      handlleJoinRef.current = true;
    }
    if (savecallDuration && savecallDuration != 0 && savecallDuration != undefined) {
      setUpdateSub(false);
      handleUpdateSimulationTime();
    } else {
      if (loadingPlanShowing == false || loadingPlanShowing == undefined) {
        if (ApicCall.current == false) {
          // getUserSubscription();
          ApicCall.current = true;
        }
      } else {
        setTimeout(() => {
          calling();
        }, 8000);
      }
    }
  }, []);

  if (hideHeader) return null;

  return (
    <header className="bg-white h-20 sticky top-0 z-10 flex justify-between items-center">
      <h1 className="text-darkBlue font-semibold text-2xl">{pageTitle}</h1>
      {isDashboard && <TivyChat userId={user.id} userName={user.firstName} />}
    </header>
  );
}
